export const TRANSCRIPT_TAB = { value: "Transcript" } as const;
export const HIGHLIGHTS_TAB = { value: "Highlights" } as const;
export const CLIPS_TAB = { value: "Clips" } as const;
export const STATS_TAB = { value: "Stats" } as const;
